
import { useCelebration } from '../../Hooks/Features/employeeDashboard/useCelebration';
import { TabView, TabPanel } from 'primereact/tabview';
import { SkeletonContainer } from '../Loader/Loader';


const CelebrationWidget = () => {
    const { employees, activeIndex, setActiveIndex, EmployeeCard, loader, headerTemplate } = useCelebration();


    return (
        <div className='celebration-widget employee-dash-height'>
            {loader ? <SkeletonContainer /> :
                <TabView activeIndex={activeIndex} onTabChange={(e) => {
                    setActiveIndex(e.index)
                }}>
                    <TabPanel header="Birthday" headerTemplate={(e) => headerTemplate(e, employees?.birthday.length, "Birthday")}>
                        <EmployeeCard type='birthday' />
                    </TabPanel>
                    <TabPanel header="Anniversary" headerTemplate={(e) => headerTemplate(e, employees?.anniversary.length, "Anniversary")}>
                        <EmployeeCard type='anniversary' />
                    </TabPanel>
                    <TabPanel header="New Joinee" headerTemplate={(e) => headerTemplate(e, employees?.newJoinee.length, "New Joinee")}>
                        <EmployeeCard type='newJoinee' />
                    </TabPanel>
                </TabView>

            }
        </div>);
};

export default CelebrationWidget;